import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getApkBackups } from '../../utilities/api';

export const fetchApkBackups = createAsyncThunk('mobileBillingApp/fetch', async (params = {}, { rejectWithValue }) => {
    try {
        return await getApkBackups(params);
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch APK entries');
    }
});

const initialState = {
    apkData: [],
    loading: false,
    error: null
};

const mobileBillingAppSlice = createSlice({
    name: 'mobileBillingApp',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchApkBackups.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchApkBackups.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload;
                const data = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
                // A row saved before the status column had a default still has to land in
                // one of the two status tabs, so treat a blank status as Active.
                state.apkData = data.map((a) => ({ ...a, status: a.status || 'Active' }));
            })
            .addCase(fetchApkBackups.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.apkData = [];
            });
    }
});

export const { clearError } = mobileBillingAppSlice.actions;

export const selectApkData = (state) => state.mobileBillingApp.apkData;
export const selectLoading = (state) => state.mobileBillingApp.loading;
export const selectError = (state) => state.mobileBillingApp.error;

export default mobileBillingAppSlice.reducer;
